<template>
	<div>
		<vxe-modal v-model="modal" :loading="loading" title="付款汇款汇总" width="1200" height="800" @show="show" show-footer>
			<template #default>
				<div style="margin-bottom: 20px;">
					<el-divider content-position="left">结算进度</el-divider>
					<el-row :gutter="20">
						<el-col :span="6">
							<div>
								<el-statistic title="月结">
									<template slot="formatter">
										<span v-if="staticData && staticData['月结']">
											{{staticData['月结'].settlement+'/'+staticData['月结'].total}}
										</span>
									</template>
								</el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic title="现金">
									<template slot="formatter">
										<span v-if="staticData && staticData['现结']">
											{{staticData['现结'].settlement+'/'+staticData['现结'].total}}
										</span>
									</template>
								</el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic title="预付款">
									<template slot="formatter">
										<span v-if="staticData && staticData['预付款']">
											{{staticData['预付款'].settlement+'/'+staticData['预付款'].total}}
										</span>
									</template>
								</el-statistic>
							</div>
						</el-col>
						<el-col :span="6">
							<div>
								<el-statistic title="未定义">
									<template slot="formatter">
										<span v-if="staticData && staticData['未定义']">
											{{staticData['未定义'].settlement+'/'+staticData['未定义'].total}}
										</span>
									</template>
								</el-statistic>
							</div>
						</el-col>
					</el-row>
				</div>
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="statisticsExport">导出统计</vxe-button>
						<vxe-button status="primary" @click="statisticsExportDetail">导出明细</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="statistics" footer-cell-class-name="footerCellColor" :show-footer="true"
					:footer-method="footerMethod" border show-overflow height="400" :data="tableData">
					<vxe-column type="seq" width="60"></vxe-column>
					<vxe-column field="voucherno" title="凭证号"></vxe-column>
					<vxe-column field="supplierName" title="供应商"></vxe-column>
					<vxe-column field="paymentmethod" :filters="paymentmethodFilter" title="结算方式"></vxe-column>
					<vxe-column field="settlementStatus" :filters="settlementStatusFilter" title="结算状态">
						<template #default="{ row }">
							<span v-if="row.settlementStatus==1">待结算</span>
							<span v-if="row.settlementStatus==2">已结算</span>
							<span v-if="row.settlementStatus==3">已结清</span>
							<span v-if="row.settlementStatus==5">部分结算</span>
						</template>
					</vxe-column>
					<vxe-column sortable field="ordernum" title="单据数量">
						<template #default="{ row }">
							<el-link type="primary" @click="showorderdetail(row)">{{row.ordernum}}</el-link>
						</template>
					</vxe-column>
					<vxe-column sortable field="debt" title="金额"></vxe-column>
				</vxe-table>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			</template>
		</vxe-modal>
		<detail-index :tableData="detaildata" ref="detailIndex" />
	</div>
</template>
<style scoped>

</style>
<script>
	import detailIndex from './detail/index'
	export default {
		props: {
			nodeid: {
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				staticData: null,
				sourcedata:[],
				selectTab: 'account',
				modal: false,
				loading: false,
				tableData: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
				paymentmethodFilter: [{
						label: '月结',
						value: '月结'
					},
					{
						label: '现结',
						value: '现结'
					},
					{
						label: '预付款',
						value: '预付款'
					},
					{
						label: '未定义',
						value: '未定义'
					},
				],
				settlementStatusFilter:[
					{ label: '待结算', value: '1' },
					{ label: '已结算', value: '2' },
					{ label: '已结清', value: '3' },
					{ label: '部分结算', value: '5' },
				],
				detaildata:[]
			}
		},
		watch: {
			selectTab(){
				this.init()
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.loading = true
				this.tableData = []
				this.$api.purchaseoutstockbill.list({
					nodeid: this.nodeid,
					currentPage:-1
				}).then((res) => {
					this.sourcedata = JSON.parse(JSON.stringify(res.list))
					this.tableData = this.initData(res.list)
					let groupedData = this.$Lodash.groupBy(this.tableData, 'paymentmethod')
					for (let i in groupedData) {
						groupedData[i] = {
							total: groupedData[i].length,
							settlement: groupedData[i].filter((item) => {
								return item.settlementStatus != 1
							}).length
						}
					}
					this.staticData = groupedData
					//console.log(this.staticData)
					this.loading = false
				})
			},
			initData(data) {
				// let map = {
				// 	"1":'待结算',
				// 	"2":'已结算',
				// 	"3":'已结清',
				// 	"5":'部分结算',
				// }
				let tabledata = []
				let groupedData = this.$Lodash.groupBy(data, 'supplierName')
				for (let i in groupedData) {
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'settlementStatus')
				}
				
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						if (groupedData[i][j][0].paymentmethod == 8806) {
							obj.paymentmethod = '月结'
						} else if (groupedData[i][j][0].paymentmethod == 8805) {
							obj.paymentmethod = '现结'
						} else if (groupedData[i][j][0].paymentmethod == 8825) {
							obj.paymentmethod = '预付款'
						} else {
							obj.paymentmethod = '未定义'
						}
						obj.voucherno = groupedData[i][j][0].voucherno
						obj.supplierName = i
						obj.settlementStatus = j
						obj.debt = this.$Lodash.sumBy(groupedData[i][j], item => parseFloat(item.debt))
						obj.debt = obj.debt.toFixed(2)
						obj.ordernum = groupedData[i][j].length
						obj.order = groupedData[i][j]
						tabledata.push(obj)
					}
				}
				return tabledata
			},
			showorderdetail(row){
				this.detaildata = row.order
				this.$refs.detailIndex.modalShow()
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			statisticsExport() {
				this.$refs.statistics.exportData({
					type: 'xlsx'
				})
			},
			statisticsExportDetail(){
				let detail = []
				let data = this.$refs.statistics.getTableData().visibleData
				data.forEach((item)=>{
					detail = detail.concat(item.order)
				})
				this.$emit('exportdetail',{data:detail})
			},
			footerMethod({
				data
			}) {
				let debt = 0
				let ordernum = 0
				data.forEach((item) => {
					debt += item.debt ? parseFloat(item.debt) : 0
					ordernum += item.ordernum ? parseFloat(item.ordernum) : 0
				})
				return [
					['合计', '', '', '', '',ordernum,debt.toFixed(2)]
				]
			}
			// spanMethod({
			// 	row,
			// 	_rowIndex,
			// 	column,
			// 	visibleData
			// }) {
			// 	const fields = ['accName']
			// 	const cellValue = row[column.property]
			// 	if (cellValue && fields.includes(column.property)) {
			// 		if (column.property == 'code' || column.property == 'commit_time' || column.property == 'img_file') {
			// 			const prevRow = visibleData[_rowIndex - 1]
			// 			let nextRow = visibleData[_rowIndex + 1]
			// 			if (prevRow && JSON.stringify(prevRow[column.property]) === JSON.stringify(cellValue)) {
			// 				return {
			// 					rowspan: 0,
			// 					colspan: 0
			// 				}
			// 			} else {
			// 				console.log(nextRow[column.property], cellValue)
			// 				let countRowspan = 1
			// 				while (nextRow && JSON.stringify(nextRow[column.property]) === JSON.stringify(cellValue)) {
			// 					nextRow = visibleData[++countRowspan + _rowIndex]
			// 				}
			// 				if (countRowspan > 1) {
			// 					return {
			// 						rowspan: countRowspan,
			// 						colspan: 1
			// 					}
			// 				}
			// 			}
			// 		} else {
			// 			if (!(_rowIndex % 2)) {
			// 				return {
			// 					rowspan: 2,
			// 					colspan: 1
			// 				}
			// 			} else {
			// 				return {
			// 					rowspan: 0,
			// 					colspan: 0
			// 				}
			// 			}
			// 		}
			// 	}
			// },
		},
		components: {
			detailIndex
		}
	}
</script>